export default __webpack_public_path__ + "static/media/93t.97da5225.jpg";